import './BlogPage.css'
import MainLayout from '../../layouts/MainLayout/MainLayout'
import BlogCard from '../../components/Blog/BlogCard/BlogCard';
import { useFetch } from '../../hooks/useFetch';
import { Loader, Center } from '@mantine/core';

export default function BlogPage() {


   const { data,
      error,
      isLoading } = useFetch(`${process.env.REACT_APP_BACKEND_SERVER}/info/blog`)

   const sortedData = [...(data || [])].sort(
      (a, b) => new Date(b.date) - new Date(a.date)
   );

   const latestPosts = sortedData.slice(0, 4);
   const restOfPosts = sortedData.slice(4);


   return (
      <MainLayout >
         <section className='BlogPage-main-container'>
            <h1 className='BlogPage--pageTitle'>Blog de Novedades</h1>
            <hr />

            {isLoading ? <Center>
               <Loader />
            </Center>
               : <div className='BlogPage-wrapper-content'>
                  <div className='BlogPage-lastPost-container'>
                     {latestPosts.map((item, idx) => (
                        <BlogCard
                           idx={idx}
                           isLatest
                           item={item}
                           key={item._id}
                        />
                     ))}

                  </div>
                  <div className='BlogPage-generalPost-container'>
                     {restOfPosts && restOfPosts.map(item => (
                        <BlogCard
                           item={item}
                           key={item._id}
                        />
                     ))}
                  </div>
               </div>
            }


         </section>
      </MainLayout>
   )
}
